const initialState = {
  fabric: {
    text: "Plush",
    value: "plush",
    colors: [
      "Steel",
      "Silver",
      "Grey",
      "Black",
      "Mustard Blue",
      "Duck Egg",
      "Biege",
      "Teal",
      "Saphire",
      "Maroon",
    ],
  },
  color: "Steel",
  size: {},
  sofaType: "Corner Sofa",
};

const FReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_F_SIZE":
      return {
        ...state,
        size: action.payload,
      };
    case "SET_F_COLOR":
      return {
        ...state,
        color: action.payload,
      };
    case "SET_F_FABRIC":
      return {
        ...state,
        fabric: action.payload,
        color: action.payload.colors[0],
      };
    case "SET_F_SOFATYPE":
      return {
        ...state,
        sofaType: action.payload,
      };

    default:
      return state;
  }
};

export default FReducer;
